import { Pinia, Store } from 'pinia-class-component';
import { Duty, DutyClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'DutyStore',
  name: 'DutyStore',
})
export default class DutyStore extends Pinia {
  private readonly dutyApi = initClient(DutyClient);

  //data
  private _loadingPromise: Promise<Duty[]> | null = null;
  private _duties: Duty[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get duties(): Duty[] {
    return this._duties;
  }

  //actions
  clear(): void {
    this._duties.splice(0);
  }

  setDuties(dutys: Duty[]): void {
    this._duties.splice(0);
    this._duties.push(...dutys);
  }

  addDuty(duty: Duty): void {
    this._duties.push(duty);
  }

  updateDuty(duty: Duty): void {
    const index = this._duties.findIndex(e => e.dutyId == duty.dutyId);
    if (index >= 0) {
      this._duties.splice(index, 1, duty);
    } else {
      this._duties.push(duty);
    }
  }

  forgetDuty(duty: Duty): void {
    const index = this._duties.findIndex(e => e.dutyId == duty.dutyId);
    if (index >= 0) {
      this._duties.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.dutyApi.getDutiesData().then(e => e.duties);
      const duties = await this._loadingPromise;
      this.setDuties(duties);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._duties.length > 0) {
      return;
    }
    return await this.reload();
  }
}